import React, { useState, useEffect, useCallback, useRef, KeyboardEvent, ChangeEvent } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
// import ActiveInstallationsMap from "components/ActiveInstallationsMap";
import ActiveInstallationsMapInBrokerageAndAgent from "components/ActiveInstallationsMapInBrokerageAndAgent";

const mapContainerStyle = {
    width: "100%",
    height: "500px",
    borderRadius: "12px",
    overflow: "hidden",
    //   boxShadow: "0 0 10px rgba(0,0,0,0.1)", // Soft shadow
    //   border: "1px solid #dee2e6",          // Light border
};
import { getAuthCookie } from "../../utils/authCookies";

const center = {
    lat: 40.712776, // Default latitude (e.g., New York City)
    lng: -74.005974, // Default longitude
};

const RealtorActiveInstallations = () => {
    const mapRef = useRef<google.maps.Map | null>(null);
    const [globalFilter, setGlobalFilter] = useState("");
    const [searchInput, setSearchInput] = useState<string>(globalFilter ?? "");
    const [statusFilter, setStatusFilter] = useState("");
    const [dateRange, setDateRange] = useState("last_15_days");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const [installationLocations, setInstallationLocations] = useState<any[]>([]);
    const [selectedInstallation, setSelectedInstallation] = useState<any | null>(null);


    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [deleting, setDeleting] = useState<string | null>(null);
    const token = getAuthCookie("sessionToken");
    const location = useLocation();
    const isTeammember = location.pathname.includes('/teammember');
    const baseRoute = isTeammember ? '/teammember' : '/realtor';
    const navigate = useNavigate();
    const [selectedLocation, setSelectedLocation] = useState<{
        lat: number;
        lng: number;
    } | null>(null);
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string, // Replace with your API key
    });

    const handleMapClick = useCallback((event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            setSelectedLocation({ lat, lng });
        }
    }, []);

    // useEffect(() => {
    //     const fetchInstallationLocations = async () => {
    //         try {
    //             const res = await fetch(`${process.env.REACT_APP_API_URL}/installation_locations`, {
    //                 headers: { Authorization: `Bearer ${token}` },
    //             });

    //             const data = await res.json();
    //             if (!res.ok) throw new Error(data.message || "Failed to load locations");
    //             console.log("Fetched Installation Locations:", data.locations);
    //             setInstallationLocations(data.locations || []);
    //         } catch (err: any) {
    //             console.error("Error loading locations:", err.message);
    //             toast.error("Failed to load installation markers");
    //         }
    //     };

    //     fetchInstallationLocations();
    // }, []);

    const getInstallationLocationById = async (locationId: string) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/installation_locations/${locationId}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Failed to fetch location");

            console.log("Installation Location:", data);
            return data;
        } catch (error: any) {
            console.error("Fetch Location Error:", error.message);
            toast.error("Failed to fetch installation location.");
            return null;
        }
    };

    const handleSearch = async () => {
        setSelectedInstallation(null); // Reset selected installation on new search
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/installation_locations/map/user`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        search: globalFilter,
                        status: statusFilter ? parseInt(statusFilter) : null,
                        date_range:
                            dateRange === "custom"
                                ? {
                                    type: "custom",
                                    from: fromDate,
                                    to: toDate,
                                }
                                : {
                                    type:
                                        dateRange === "last_15_days"
                                            ? "last_15_days"
                                            : dateRange === "yesterday"
                                                ? "yesterday"
                                                : "today",
                                    from: "",
                                    to: "",
                                },
                    }),
                }
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || "Failed to fetch map data");
            }

            console.log("Map API results:", result);
            setInstallationLocations(result.locations || []); // ⬅️ Adjust if response shape is different
            // toast.success("Map data loaded.");
        } catch (error: any) {
            console.error("Search failed:", error.message);
            toast.error("Failed to load map data.");
        }
    };


    function getOffsetPosition(lat: number, lng: number, index: number, offset = 0.00005) {
        const angle = (index * 45) * (Math.PI / 180); // 0°, 45°, 90°, etc.
        console.log("agle", angle, "offset", offset);
        return {
            lat: lat + offset * Math.cos(angle),
            lng: lng + offset * Math.sin(angle),
        };
    }

    // Utility to round lat/lng to prevent floating-point errors
    function roundCoord(num: number) {
        return Number(num?.toFixed(5));
    }

    // Create a map: "lat,lng" => [orders...]
    const locationGroups = installationLocations.reduce((acc, loc) => {
        const lat = roundCoord(loc?.address?.address_details?.latitude ?? 0);
        const lng = roundCoord(loc?.address?.address_details?.longitude ?? 0);
        const key = `${lat},${lng}`;
        if (!acc[key]) acc[key] = [];
        acc[key].push(loc);
        return acc;
    }, {} as Record<string, any[]>);



    return (
        // <div className="content">
        //     <div className="page-container ">
        //         <h3 className="m-0  fw-bold ">Active Installations Map</h3>
        //     </div>
        //     <div className="align-items-center d-flex mb-3 row justify-content-between">
        //         {/* Selects container */}
        //         <div className="col-md-8 d-flex gap-3 align-items-center flex-nowrap">
        //             <div className="col-md-2">
        //                 <select
        //                     className="form-control br-8"
        //                     value={statusFilter}
        //                     onChange={(e) => setStatusFilter(e.target.value)}
        //                 >
        //                     <option value="">All Statuses</option>
        //                     <option value="200">Finalized</option>
        //                     <option value="300">Scheduled</option>
        //                     <option value="400">InProgress</option>
        //                     <option value="500">Completed</option>
        //                 </select>
        //             </div>
        //             <div className="col-md-2">
        //                 <select
        //                     className="form-control br-8"
        //                     value={dateRange}
        //                     onChange={(e) => setDateRange(e.target.value)}
        //                 >
        //                     <option value="today">Today</option>
        //                     <option value="yesterday">Yesterday</option>
        //                     <option value="last_15_days">Last 15 Days</option>
        //                     <option value="custom">Date Range</option>
        //                 </select>
        //             </div>
        //             {dateRange === "custom" && (
        //                 <div className="d-flex gap-2">
        //                     <div>
        //                         <label className="m-0">From:</label>
        //                         <input
        //                             type="date"
        //                             className="form-control form-control-sm"
        //                             value={fromDate}
        //                             onChange={(e) => setFromDate(e.target.value)}
        //                         />
        //                     </div>
        //                     <div>
        //                         <label className="m-0">To:</label>
        //                         <input
        //                             type="date"
        //                             className="form-control form-control-sm"
        //                             value={toDate}
        //                             onChange={(e) => setToDate(e.target.value)}
        //                         />
        //                     </div>
        //                 </div>
        //             )}
        //             <div className="col-md-2 d-flex align-items-end ">
        //                 <button className="btn btn-primary" onClick={() => handleSearch()}>
        //                     Apply Filter
        //                 </button>
        //             </div>

        //         </div>

        //         {/* Search bar container */}
        //         {/* <div className="col-md-6 gap-3 d-flex justify-content-end">
        //             Search bar container
        //             <div className="col-md-3 d-flex justify-content-end">
        //                 <div
        //                     className="input-group"
        //                     style={{ width: "230px", height: "40px" }}
        //                 >
        //                     <span className="input-group-text bg-white border-end-0 p-2 left-radius">
        //                         <i className="ri-search-line fs-15"></i>
        //                     </span>
        //                     <input
        //                         type="text"
        //                         className="form-control border-start-0 ps-0 right-radius text-ellipsis"
        //                         placeholder="Search by Name,Email "
        //                         value={searchInput}
        //                         onChange={(e: ChangeEvent<HTMLInputElement>) =>
        //                             setSearchInput(e.target.value)
        //                         }
        //                         onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
        //                             if (e.key === "Enter") {
        //                                 setGlobalFilter(searchInput);
        //                             }
        //                         }}
        //                         style={{ borderColor: "#cccccc" }}
        //                     />
        //                 </div>
        //             </div>
        //         </div> */}
        //     </div>
        //     {/* <h2>Active Installations Map </h2>
        //             <div className="row mb-3 align-items-end">
        //                 <div className="col-md-3">
        //                     <select
        //                         className="form-control"
        //                         value={statusFilter}
        //                         onChange={(e) => setStatusFilter(e.target.value)}
        //                     >
        //                         <option value="">All Statuses</option>
        //                         <option value="200">Finalized</option>
        //                         <option value="300">Scheduled</option>
        //                         <option value="400">InProgress</option>
        //                         <option value="500">Completed</option>
        //                     </select>
        //                 </div>

        //                 <div className="col-md-3">
        //                     <select
        //                         className="form-control"
        //                         value={dateRange}
        //                         onChange={(e) => setDateRange(e.target.value)}
        //                     >
        //                         <option value="today">Today</option>
        //                         <option value="yesterday">Yesterday</option>
        //                         <option value="last_15_days">Last 15 Days</option>
        //                         <option value="custom">Date Range</option>
        //                     </select>
        //                     {dateRange === "custom" && (
        //                         <div className="d-flex gap-2">
        //                             <div>
        //                                 <label>From:</label>
        //                                 <input
        //                                     type="date"
        //                                     className="form-control  form-control-sm"
        //                                     value={fromDate}
        //                                     onChange={(e) => setFromDate(e.target.value)}
        //                                 />
        //                             </div>
        //                             <div>
        //                                 <label>To:</label>
        //                                 <input
        //                                     type="date"
        //                                     className="form-control  form-control-sm"
        //                                     value={toDate}
        //                                     onChange={(e) => setToDate(e.target.value)}
        //                                 />
        //                             </div>
        //                         </div>
        //                     )}
        //                 </div>

        //                 <div className="col-md-4">
        //                     <input
        //                         type="text"
        //                         className="form-control"
        //                         placeholder="Search Order by Order ID"
        //                         value={searchQuery}
        //                         onChange={(e) => setSearchQuery(e.target.value)}
        //                     />
        //                 </div>

        //                 <div className="col-md-2">
        //                     <button className="btn btn-primary w-100" onClick={handleSearch}>
        //                         Search
        //                     </button>
        //                 </div>
        //             </div> */}

        //     <div className="row">
        //         <div className="col-md-9">
        //             <div style={mapContainerStyle}>
        //                 {isLoaded && (
        //                     <GoogleMap
        //                         mapContainerStyle={mapContainerStyle}
        //                         zoom={10}
        //                         center={selectedLocation || center}
        //                         // onClick={handleMapClick}
        //                         onLoad={(map) => {
        //                             mapRef.current = map;
        //                         }}
        //                     >
        //                         {/* 🟢 Fetched installation markers */}
        //                         {installationLocations?.map((loc, idx) => {
        //                             const a = loc.address?.address_details;
        //                             const lat = roundCoord(a?.latitude);
        //                             const lng = roundCoord(a?.longitude);
        //                             if (!lat || !lng || isNaN(lat) || isNaN(lng)) return null;

        //                             const key = `${lat},${lng}`;
        //                             const group = locationGroups[key];
        //                             const groupSize = group.length;

        //                             let markerColor = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
        //                             switch (loc.status) {
        //                                 // case 100: markerColor = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"; break;
        //                                 case 200: markerColor = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"; break;
        //                                 case 300: markerColor = "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"; break;
        //                                 // case 400: markerColor = "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"; break;
        //                                 case 400: markerColor = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"; break;
        //                                 // case 500: markerColor = "http://maps.google.com/mapfiles/ms/icons/purple-dot.png"; break;
        //                                 case 500: markerColor = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"; break;
        //                                 case 600: markerColor = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"; break;
        //                             }

        //                             // Tooltip message
        //                             const title =
        //                                 groupSize > 1
        //                                     ? `📦 ${groupSize} installations here — zoom in to see individually`
        //                                     : `Order: ${loc.order_number}`;

        //                             return (
        //                                 <Marker
        //                                     key={idx}
        //                                     position={getOffsetPosition(lat, lng, idx)}
        //                                     icon={{ url: markerColor }}
        //                                     title={title} // ✅ hover message
        //                                     onClick={async () => {
        //                                         try {
        //                                             const details = await getInstallationLocationById(loc._id);
        //                                             if (!details) return;
        //                                             setSelectedInstallation(details);

        //                                             const statusMap: Record<number, string> = {
        //                                                 100: "Draft",
        //                                                 200: "Finalized",
        //                                                 300: "Scheduled",
        //                                                 400: "In Progress",
        //                                                 500: "Completed",
        //                                                 600: "Canceled",
        //                                             };
        //                                             const member = details.agent_name || details.office?.officeName || "N/A";
        //                                             const infoWindow = new google.maps.InfoWindow({
        //                                                 content: `
        //         <div>
        //           <b>📦 Product:</b> ${details.product_name || "N/A"}<br/>
        //           <b>📅 Date:</b> ${details.scheduled_date ? new Date(details.scheduled_date).toDateString() : "N/A"}<br/>
        //           <b>⚙️ Status:</b> ${statusMap[details.status] || "Unknown"}<br/>
        //           <b>👤 Member:</b> ${member}
        //         </div>
        //       `,
        //                                             });

        //                                             infoWindow.setPosition({ lat, lng });
        //                                             infoWindow.open(mapRef.current);
        //                                         } catch (err) {
        //                                             toast.error("Failed to fetch marker data");
        //                                             console.error(err);
        //                                         }
        //                                     }}
        //                                 />
        //                             );
        //                         })}
        //                     </GoogleMap>

        //                 )}
        //             </div>
        //                 <ActiveInstallationColorBar />
        //         </div>
        //         {/* <div className="col-md-3">
        //             <h3>Installation Details</h3>
        //             {selectedInstallation ? (
        //                 <>
        //                     <div className="mb-3">
        //                         <strong>Address:</strong>
        //                         <p>{selectedInstallation?.address?.label || `${selectedInstallation?.address?.city}, ${selectedInstallation?.address?.state}`}</p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <strong>Scheduled Date:</strong>
        //                         <p>{selectedInstallation?.scheduled_date ? new Date(selectedInstallation.scheduled_date).toDateString() : "N/A"}</p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <strong>Agent / Office / Brokerage:</strong>
        //                         <p>{selectedInstallation?.agent_name || selectedInstallation?.office?.officeName || selectedInstallation?.brokerage_firm_name || "N/A"}</p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <strong>Product:</strong>
        //                         <p>{selectedInstallation?.product_name || "N/A"}</p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <strong>Status:</strong>
        //                         <p className="status-badge status-pending">
        //                             {
        //                                 selectedInstallation?.status === 100 ? "Draft"
        //                                     :
        //                                     selectedInstallation?.status === 200 ? "Finalized"
        //                                         :
        //                                         selectedInstallation?.status === 300 ? "Scheduled"
        //                                             :
        //                                             selectedInstallation?.status === 400 ? "In Progress"
        //                                                 :
        //                                                 selectedInstallation?.status === 500 ? "Completed"
        //                                                     :
        //                                                     selectedInstallation?.status === 600 ? "Canceled"
        //                                                         : "Unknown"
        //                             }
        //                         </p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <Link
        //                             to={`${baseRoute}/jobs/viewInstallation/${selectedInstallation?.order_id}`}
        //                             className="btn btn-info btn-block"
        //                             style={{ width: "100%" }}
        //                         >
        //                             View Order
        //                         </Link>
        //                     </div>
        //                     {selectedInstallation?.status === 500 && (
        //                         <div className="mb-3">
        //                             <Link
        //                                 to={`#`}
        //                                 className="btn btn-danger btn-block"
        //                                 style={{ width: "100%" }}
        //                             >
        //                                 Request Removal
        //                             </Link>
        //                         </div>
        //                     )}
        //                 </>
        //             ) : (
        //                 <p>Select a marker to view installation details.</p>
        //             )}


        //         </div> */}

        //         <div className="col-md-3">
        //             <h3 className="text-center table-headers">Installation Details</h3>
        //             {selectedInstallation ? (
        //                 <>
        //                     <div className="mb-3">
        //                         <p className="table-headers d-inline-block">Address:</p>
        //                         <p className="table-cell ms-1">{selectedInstallation?.address?.label || `${selectedInstallation?.address?.city}, ${selectedInstallation?.address?.state}`}</p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <p className="table-headers d-inline-block">Scheduled Date:</p>
        //                         <p className="table-cell ms-1">{selectedInstallation?.scheduled_date ? new Date(selectedInstallation.scheduled_date).toDateString() : ""}</p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <p className="table-headers d-inline-block">Agent / Office / Brokerage:</p>
        //                         <p className="table-cell ms-1">{selectedInstallation?.agent_name || selectedInstallation?.office?.officeName || selectedInstallation?.brokerage_firm_name || ""}</p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <p className="table-headers d-inline-block">Order:</p>
        //                         <p className="table-cell ms-1">{selectedInstallation?.order_number || ""}</p>
        //                     </div>
        //                     <div className="mb-3">
        //                         <p className="table-headers d-inline-block">Status : </p>
        //                         <p className="status-badge table-cell ms-1">
        //                             <InstallationStatusBadge value={selectedInstallation?.status as number} type="order" />
        //                         </p>
        //                     </div>
        //                     <div className="row">
        //                         <div className="col-md-5">
        //                             <Link
        //                                 to={`${baseRoute}/jobs/viewInstallation/${selectedInstallation?.order_id}`}
        //                                 className="btn btn-info btn-block"
        //                                 style={{ width: "100%" }}
        //                             >
        //                                 View Order
        //                             </Link>
        //                         </div>
        //                         {selectedInstallation?.status === 500 && (
        //                             <div className="col-md-5">
        //                                 <Link
        //                                     to={`${baseRoute}/jobs/addRemovalRequest/${selectedInstallation?.order_id}`}
        //                                     className="btn btn-danger btn-block"
        //                                     style={{ width: "100%" }}
        //                                 >
        //                                     Request Removal
        //                                 </Link>
        //                             </div>
        //                         )}
        //                     </div>
        //                 </>
        //             ) : (
        //                 <p className="text-center table-cells">Select a marker to view installation details.</p>
        //             )}


        //         </div>
        //     </div>
        // </div>
        <>
            <ActiveInstallationsMapInBrokerageAndAgent
                title="Active Installations"
                searchUrl={`${process.env.REACT_APP_API_URL}/installation_locations/map/user`}
                detailsUrl={(id) => `${process.env.REACT_APP_API_URL}/installation_locations/${id}`}
                viewOrderHref={(orderId) => `${baseRoute}/jobs/viewInstallation/${orderId}`}
                requestRemovalHref={(orderId) => `${baseRoute}/jobs/addRemovalRequest/${orderId}`}
                initialZoom={10}
            />
        </>
    );
};

export default RealtorActiveInstallations;
